import React, { useEffect, useState } from "react";
import { Heart, Bell, Bookmark } from "lucide-react";
import api from "@/lib/api";
import { SEASONS } from "@/lib/seasons";

const meta = (slug) => SEASONS.find((s) => s.slug === slug) || { label: slug, emoji: "✨" };

export default function HeartsCard() {
  const [data, setData] = useState(null);
  const [showAll, setShowAll] = useState(false);
  useEffect(() => { api.get("/admin/seasons/hearts").then(({ data }) => setData(data)).catch(() => setData({ items: [], waiting: {}, total_hearts: 0 })); }, []);
  if (!data) return null;
  const rows = showAll ? data.items : data.items.slice(0, 8);
  const max = Math.max(1, ...data.items.map((i) => i.hearts));
  const waiting = Object.entries(data.waiting || {});

  return (
    <div className="bg-white rounded-3xl soft-shadow p-6 mb-4" data-testid="hearts-card">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <h3 className="font-display font-bold text-[#19324A] inline-flex items-center gap-2"><Heart className="w-4 h-4 text-[#FF6B9D] fill-[#FF6B9D]" /> Most-hearted coming-soon pieces</h3>
          <p className="text-xs text-[#19324A]/50 mt-0.5">Hearts = wishlist saves + "remind me when it opens" sign-ups. Stock up on what's climbing.</p>
        </div>
        <div className="text-right">
          <p className="font-display font-extrabold text-2xl text-[#19324A]" data-testid="hearts-total">{data.total_hearts}</p>
          <p className="text-[11px] uppercase tracking-wider text-[#19324A]/45">total hearts</p>
        </div>
      </div>
      {waiting.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2" data-testid="hearts-waiting">
          {waiting.map(([slug, n]) => <span key={slug} className="inline-flex items-center gap-1 rounded-full bg-[#FFD93D]/30 text-[#19324A] text-xs font-semibold px-2.5 py-1"><Bell className="w-3 h-3" /> {meta(slug).emoji} {n} waiting for {meta(slug).label}</span>)}
        </div>
      )}
      {rows.length === 0 ? (
        <p className="text-sm text-[#19324A]/55 mt-4" data-testid="hearts-empty">No seasonal pieces have been hearted yet — share the sneak-peek link to get the hearts rolling.</p>
      ) : (
        <ul className="mt-4 divide-y divide-[#19324A]/5" data-testid="hearts-list">
          {rows.map((i, idx) => (
            <li key={i.id} className="py-2.5 flex items-center gap-3" data-testid={`hearts-row-${i.slug}`}>
              <span className="w-5 text-xs font-bold text-[#19324A]/40 tabular-nums">{idx + 1}</span>
              <img src={i.image || ""} alt="" className="w-10 h-10 rounded-xl object-cover bg-[#FFF9EE]" />
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold text-[#19324A] truncate">{meta(i.seasonal).emoji} {i.name}</p>
                <div className="mt-1 h-1.5 rounded-full bg-[#19324A]/5 overflow-hidden"><div className="h-full rounded-full bg-[#FF6B9D]" style={{ width: `${Math.round((i.hearts / max) * 100)}%` }} /></div>
              </div>
              <div className="text-right shrink-0">
                <p className="font-display font-extrabold text-[#19324A]" data-testid={`hearts-count-${i.slug}`}>{i.hearts}</p>
                <p className="text-[10px] text-[#19324A]/50 inline-flex items-center gap-1"><Bookmark className="w-3 h-3" />{i.wishlists} · <Bell className="w-3 h-3" />{i.reminders}</p>
              </div>
              <span className={`shrink-0 text-[10px] font-bold rounded-full px-2 py-0.5 ${i.printify ? "bg-[#4CC9F0]/15 text-[#0E7490]" : i.stock <= 5 ? "bg-[#FF6B9D]/15 text-[#B91C1C]" : "bg-[#7ED957]/20 text-[#166534]"}`}>
                {i.printify ? "POD" : `${i.stock} in stock`}
              </span>
            </li>
          ))}
        </ul>
      )}
      {data.items.length > 8 && <button onClick={() => setShowAll((v) => !v)} className="mt-3 text-xs font-semibold text-[#4CC9F0] hover:underline" data-testid="hearts-toggle">{showAll ? "Show top 8" : `Show all ${data.items.length}`}</button>}
    </div>
  );
}
